import type { Route } from '@angular/router';
import { FrontOfficeContractsPermissions } from '@clean-code/shared/frontoffice/util-permissions';

export const contractsListRoutes: Route = {
  path: 'contracts',
  children: [
    {
      path: '',
      loadComponent: () =>
        import('../contracts-list/contracts-list.component').then(
          (mod) => mod.ContractsListComponent,
        ),
      data: {
        permissions: {
          only: FrontOfficeContractsPermissions.sideNavPermission,
        },
      },
    },
    {
      path: 'forecast/:forecastId',
      loadComponent: () =>
        import('../contract-forecast/contract-forecast.component').then(
          (mod) => mod.ContractForecastComponent,
        ),
      data: {
        translate: 'forecast',
        permissions: {
          only: [
            FrontOfficeContractsPermissions.contractPowerForecast,
            FrontOfficeContractsPermissions.contractGasForecast,
          ],
        },
      },
    },
    {
      path: ':id/power',
      loadComponent: () =>
        import('../contract-preview/contract-preview.component').then(
          (mod) => mod.ContractPreviewComponent,
        ),
      data: {
        translate: 'contracts.preview',
        energySource: 'power',
        permissions: {
          only: FrontOfficeContractsPermissions.contractPowerViewer,
        },
      },
    },
    {
      path: ':id/gas',
      loadComponent: () =>
        import('../contract-preview/contract-preview.component').then(
          (mod) => mod.ContractPreviewComponent,
        ),
      data: {
        translate: 'contracts.preview',
        energySource: 'gas',
        permissions: {
          only: FrontOfficeContractsPermissions.contractGasViewer,
        },
      },
    },
  ],
};
